import React, { useState, useEffect } from "react";
import DataBarChart from "../../../common/DataBarChart/DataBarChart";
import { useGetCompanyTargetsChartDataQuery } from "../diagramsSlice";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../../../../features/auth/authSlice";
import { useSelector } from "react-redux";

const CompanyTargetsChart = ({
  width,
  height,
  isAutomated,
  isDisabled,
  timeInterval,
  fontSize,
  margin
}) => {
  const [type, setType] = useState("today");

  function handleChildClick(value) {
    setType(value);
  }
  const user = useSelector(selectCurrentUser);

  const {
    data: companyTargetsChartData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch
  } = useGetCompanyTargetsChartDataQuery({
    type: type,
  });

  const [companyTargetsData, setcompanyTargetsData] = useState([]);

  useEffect(() => {
    if (companyTargetsChartData) {
      const data = companyTargetsChartData.ids.map((id) => {
        return companyTargetsChartData.entities[id];
      });
      setcompanyTargetsData(data);
    }
  }, [companyTargetsChartData, type]);

  return (
    <div className="chart-container" id="barchart-container">
      {isLoading && <LoadingSpinner />}
      {companyTargetsData.length > 0 && (
        <DataBarChart
          chartData={companyTargetsData}
          title={"Today's Sales"}
          category={"company"}
          width={width}
          height={height}
          handleFilter={handleChildClick}
          isAutomated={isAutomated}
          isDisabled={isDisabled}
          timeInterval={timeInterval}
          refetch={refetch}
          fontSize={fontSize}
          margin={margin}
        />
      )}
    </div>
  );
};

export default CompanyTargetsChart;
